import StatisticTypes from './statistic.types'

const DEFAULT_PERCENT_WORD_DONT_HAVE_DEFINITION_ITEM = {
	total: 0,
	totalDontHaveDefinition: 0,
	percent: 0,
	startTime: '',
	endTime: '',
}
const INITIAL_STATE = {
	percentWordDontHaveDefinition: {
		current: DEFAULT_PERCENT_WORD_DONT_HAVE_DEFINITION_ITEM,
		prev: DEFAULT_PERCENT_WORD_DONT_HAVE_DEFINITION_ITEM,
		deltaPercentPoints: 0,
	},
}

const StatisticReducer = (state = INITIAL_STATE, action) => {
	const { type, payload } = action
	switch (type) {
		case StatisticTypes.GET_PERCENT_WORD_DONT_HAVE_DEFINITION:
			return {
				...state,
				percentWordDontHaveDefinition: {
					current: { ...payload.current },
					prev: { ...payload.prev },
					deltaPercentPoints: payload.deltaPercentPoints ?? 0,
				},
			}
		default:
			return state
	}
}

export default StatisticReducer
